// extracted by mini-css-extract-plugin
export var button = "styles-module--button--c4bc0";
export var hidden = "styles-module--hidden--066eb";